export default __webpack_public_path__ + "static/media/positionalHealthScore.4803cabf.png";